var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNpcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 82,
    viewBox: "0 0 111 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21033 30.5849V5.83898C2.21033 4.18213 3.55612 2.8396 5.21291 2.82454C28.3854 2.61386 47.7186 0.430755 65.092 18.8259C83.2435 44.0364 89.9455 48.256 105.961 49.5399C107.545 49.6668 108.789 50.9741 108.789 52.5626V77.0346C108.789 78.5011 107.728 79.7645 106.27 79.9223C81.9543 82.5556 63.8145 63.9586 57.6315 53.997C39.4559 31.7824 24.1503 32.5277 5.37012 33.5739C3.65398 33.6695 2.21033 32.3037 2.21033 30.5849Z",
    fill: "black",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.8685,
    cy: 17.7599,
    r: 17.0527,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1316,
    cy: 64.6546,
    r: 17.0527,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcLogo);
export default __webpack_public_path__ + "static/media/npcLogo.120eefe4df785657eecf0dbd26b41fe7.svg";
export { ForwardRef as ReactComponent };